import React, { Component } from "react"
import Actions from "../actions"
import constants from "../constants"
import Store from "../store"
import { gsap } from "gsap"
import { PixiPlugin } from "gsap/PixiPlugin"

class CanvasWrapper extends Component {
  constructor(props) {
    super(props)
    this.canvas = React.createRef()
    this.container = undefined
    this.app = undefined
    this.snapshot = undefined
  }
  componentDidMount() {
    const PIXI = require('pixi.js')
    gsap.registerPlugin(PixiPlugin)
    PixiPlugin.registerPIXI(PIXI)
    this.app = new PIXI.Application({ view: this.canvas.current, backgroundAlpha: 1, backgroundColor: 0xffffff, autoDensity: true, resolution: window.devicePixelRatio || 1, width: window.innerWidth, height: window.innerHeight })
    setTimeout(Actions.pixiStageReady, 0, this.app)
    this.container = new PIXI.Container()
    this.app.stage.addChild(this.container)
    window.Ticker = this.app.ticker
    window.addEventListener('resize', this.onResize)
    Store.on(constants.ADD_CHILD, this.onChildAdd)
    Store.on(constants.REMOVE_CHILD, this.onChildRemove)
    Store.on(constants.ROUTE_UPDATED, this.onRouteUpdate)
    Store.on(constants.OPEN_LOOKBOOK, this.onOpenLookbook)
    Store.on(constants.CLOSE_LOOKBOOK, this.onCloseLookbook)
  }
  componentWillUnmount() {
    this.app.stage.removeChild(this.container)
    this.app.destroy(true)
    window.removeEventListener('resize', this.onResize)
    Store.off(constants.ADD_CHILD, this.onChildAdd)
    Store.off(constants.REMOVE_CHILD, this.onChildRemove)
    Store.off(constants.ROUTE_UPDATED, this.onRouteUpdate)
    Store.off(constants.OPEN_LOOKBOOK, this.onOpenLookbook)
    Store.off(constants.CLOSE_LOOKBOOK, this.onCloseLookbook)
  }
  onChildAdd = ({ child }) => {
    this.container.addChild(child)
  }
  onChildRemove = ({ child }) => {
    this.container.removeChild(child)
  }
  onOpenLookbook = () => {
    if (window.innerWidth < constants.breakpoints.lg) return
    clearTimeout(this.appyFiltersTimeout)
    this.appyFiltersTimeout = setTimeout(this.applyFilters, 2000)
  }
  onCloseLookbook = () => {
    if (window.innerWidth < constants.breakpoints.lg) return
    this.removeFilters()
  }
  applyFilters = () => {
    this.hasFilter = true
    const PIXI = require('pixi.js')
    const elements = this.container.children[0].children
    elements.forEach(element => element.cacheAsBitmap = false)
    const base = new PIXI.BaseTexture(this.canvas.current)
    const texture = new PIXI.Texture(base)
    this.snapshot = new PIXI.Sprite(texture)
    this.snapshot.width = window.innerWidth
    this.snapshot.height = window.innerHeight
    this.app.stage.addChild(this.snapshot)
    gsap.to(this.snapshot, { duration: 0.6, ease: `linear`, pixi: { colorize: "yellow", saturation: 0.2, brightness: 1, colorizeAmount: 0.3 } } )
  }
  removeFilters = (forced=false) => {
    this.hasFilter = false
    if (!this.snapshot) return
    gsap.to(this.snapshot, { duration: 0.6, ease: `linear`, pixi: { colorMatrixFilter:null, blur:0 }, onComplete: () => {
      if (!forced) {
        const elements = this.container.children[0].children
        elements.forEach(element => element.cacheAsBitmap = true)
      }
      this.app.stage.removeChild(this.snapshot)
      this.snapshot.destroy({ children: true, texture: true, baseTexture: true })
      this.snapshot = undefined
    }})
  }
  onRouteUpdate = (route) => {
    clearTimeout(this.appyFiltersTimeout)
    if (route.new.indexOf(`story`) >= 0) this.canvas.current.style.opacity = 1
    else this.canvas.current.style.opacity = 0
    if (this.hasFilter) this.removeFilters(true)
  }
  onResize = () => {
    this.app.resize(window.innerWidth, window.innerHeight)
  }
  render() {
    return <canvas style={{ opacity: 0 }} className={`${this.props.className}`} ref={this.canvas}></canvas>
  }
}

export default CanvasWrapper
